
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91_46_46_46slug_93aAH0LXHMafOvPjXfBpSFdNOrhSlCpjLuHuRh_JbYq_454Meta } from "/vercel/path0/apps/business/pages/[...slug].vue?macro=true";
import { default as component_45stubvPpHNcoeli2dpKCHpE6t1xgnBrGZQDjHLek_GSfoUyYMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.10_@types+node@20.19.18_@vercel+blob@2.8.0_@vercel+functions@2.2.13_@aws-sdk+_383aa8d50542887f8a55cb0ed752a9a1/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubvPpHNcoeli2dpKCHpE6t1xgnBrGZQDjHLek_GSfoUyY } from "/vercel/path0/node_modules/.pnpm/nuxt@3.21.10_@types+node@20.19.18_@vercel+blob@2.8.0_@vercel+functions@2.2.13_@aws-sdk+_383aa8d50542887f8a55cb0ed752a9a1/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___en-gb",
    path: "/en-gb/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___en-au",
    path: "/en-au/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___de-at",
    path: "/de-at/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___nl-be",
    path: "/nl-be/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___fr-be",
    path: "/fr-be/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___en-ca",
    path: "/en-ca/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___fr-ca",
    path: "/fr-ca/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___da",
    path: "/da/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___en-ie",
    path: "/en-ie/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___ja",
    path: "/ja/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___no",
    path: "/no/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___pl",
    path: "/pl/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___pt",
    path: "/pt/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___sv",
    path: "/sv/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___de-ch",
    path: "/de-ch/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___fr-ch",
    path: "/fr-ch/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___it-ch",
    path: "/it-ch/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___en-nz",
    path: "/en-nz/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: "slug___en-us",
    path: "/en-us/:slug(.*)*",
    component: () => import("/vercel/path0/apps/business/pages/[...slug].vue")
  },
  {
    name: component_45stubvPpHNcoeli2dpKCHpE6t1xgnBrGZQDjHLek_GSfoUyYMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubvPpHNcoeli2dpKCHpE6t1xgnBrGZQDjHLek_GSfoUyY
  }
]